import React from 'react';
import { cn } from '../../design-system/cn';

/**
 * Social proof — arena locks and league locks (no money fields).
 */
export default function HotActivityBadges({
  openLockCount = 0,
  groupLockCount = 0,
  className,
  size = 'sm',
}) {
  const open = openLockCount || 0;
  const league = groupLockCount || 0;
  if (open <= 0 && league <= 0) return null;

  const textClass = size === 'md'
    ? 'text-[10px]'
    : 'text-[9px]';

  return (
    <div className={cn('flex flex-wrap items-center justify-center gap-2', className)}>
      {open > 0 && (
        <span
          className={cn(
            textClass,
            'font-black uppercase tracking-widest text-amber-300/95',
            'px-2 py-0.5 rounded-full border border-amber-500/30 bg-amber-500/10'
          )}
        >
          🔥 {open} active lock{open === 1 ? '' : 's'}
        </span>
      )}
      {league > 0 && (
        <span
          className={cn(
            textClass,
            'font-black uppercase tracking-widest text-violet-300/95',
            'px-2 py-0.5 rounded-full border border-violet-500/30 bg-violet-500/10'
          )}
        >
          🏆 {league} league lock{league === 1 ? '' : 's'}
        </span>
      )}
    </div>
  );
}
